import React, { Dispatch, SetStateAction } from 'react';

import { Select } from '@components/common';

import { IPresetThreshold } from '@interfaces/alarms/threshold';
import { TSelectOptionType } from '@components/common/Select/Select.types';

import styles from './PresetMenu.module.scss';

interface IPresetProps {
	isLoadingPresets: boolean;
	presetValue: TSelectOptionType<string> & IPresetThreshold | null;
	presetsThreshold: TSelectOptionType<string>[];
	setEditablePreset: Dispatch<SetStateAction<TSelectOptionType<string> & IPresetThreshold | null>>;
	setIdForDeletePreset: Dispatch<SetStateAction<string>>;
	setIsEditPresetModalOpen: Dispatch<SetStateAction<boolean>>;
	setIsOpenDeleteConfirmPreset: Dispatch<SetStateAction<boolean>>;
	setIsPresetModal: Dispatch<SetStateAction<boolean>>;
	setPresetValue: (preset: TSelectOptionType<string> & IPresetThreshold | null) => void;
}

const PresetMenu = ({
	isLoadingPresets,
	presetValue,
	presetsThreshold,
	setEditablePreset,
	setIdForDeletePreset,
	setIsEditPresetModalOpen,
	setIsOpenDeleteConfirmPreset,
	setIsPresetModal,
	setPresetValue,
}: IPresetProps) => {
	const onDeleteClick = (option: TSelectOptionType<string>) => {
		if (!option?.value) {
			return;
		}

		setIdForDeletePreset(option.value);
		setIsOpenDeleteConfirmPreset(true);
	};

	const onRenameClick = (option: TSelectOptionType<string, IPresetThreshold>) => {
		setEditablePreset(option);
		setIsPresetModal(true);
	};

	const onEditClick = (option: TSelectOptionType<string, IPresetThreshold>) => {
		setIsEditPresetModalOpen(true);
		setEditablePreset(option);
	};

	return (
		<div className={styles.selectContainer}>
			<Select
				disabled={isLoadingPresets}
				editTooltip='Edit preset'
				handleChange={setPresetValue}
				isEditable
				isRenamable
				isWithoutUseForms
				name='threshold-presets'
				onDeleteClick={onDeleteClick}
				onEditClick={onEditClick}
				onRenameClick={onRenameClick}
				options={presetsThreshold}
				placeholder='Select preset'
				renameTooltip='Rename preset'
				required
				value={presetValue}
				width='360px'
			/>
		</div>
	);
};

export default PresetMenu;
